// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2VeE1","col":"styles_col__E4IFg","fulfillmentStatus":"styles_fulfillmentStatus__17Gl1","emailCol":"styles_emailCol__29pc2"};